export default __webpack_public_path__ + "static/media/K.971a78a4.svg";